import { addDays, countWorkdaysBetween, startOfLocalDay } from '../utils/date';
import type { CountdownParts, CountdownSnapshot } from './types';

export const computeCountdownParts = (target: Date, now: Date): CountdownParts => {
    const diffMs = Math.max(0, target.getTime() - now.getTime());
    const totalMinutes = Math.floor(diffMs / (60 * 1000));

    const minutesPerHour = 60;
    const minutesPerDay = 24 * minutesPerHour;
    const minutesPerWeek = 7 * minutesPerDay;

    const weeks = Math.floor(totalMinutes / minutesPerWeek);
    const days = Math.floor((totalMinutes % minutesPerWeek) / minutesPerDay);
    const hours = Math.floor((totalMinutes % minutesPerDay) / minutesPerHour);
    const minutes = totalMinutes % minutesPerHour;

    return { weeks, days, hours, minutes };
};

export const computeCountdownSnapshot = (target: Date, now: Date): CountdownSnapshot => {
    const diffMs = Math.max(0, target.getTime() - now.getTime());
    const totalMinutes = Math.floor(diffMs / (60 * 1000));
    const totalHours = Math.floor(totalMinutes / 60);
    const totalDays = Math.floor(totalHours / 24);
    const totalWeeks = Math.floor(totalDays / 7);

    const parts = computeCountdownParts(target, now);

    const startDay = addDays(startOfLocalDay(now), 1);
    const endDay = (() => {
        const targetMidnight = startOfLocalDay(target);
        return target.getTime() > targetMidnight.getTime() ? addDays(targetMidnight, 1) : targetMidnight;
    })();
    const workdays = diffMs === 0 ? 0 : countWorkdaysBetween(startDay, endDay);

    return { now, parts, totalMinutes, totalHours, totalDays, totalWeeks, workdays };
};
